import { OrgSeason } from "@ollie-sports/models";

export function isCurrentOrgSeason(orgSeason: OrgSeason) {
  return orgSeason.startDateMS < Date.now() && orgSeason.endDateMS > Date.now();
}
